import React from 'react';
import { inject, observer } from 'mobx-react';
import './DriverPerformance.less';
import { Row, Col, Table, AppLocaleProvider, Card } from 'sd-ui-components';
import AppLayout from '../AppLayout/AppLayout';
import BackBreadcrumb from '../Common/BackBreadcrumb';
import PageLoadLogger from '../../utils/PageLoadLogger';
import Notifications from '../../components/Notifications/Notifications';
import ScorePercentage from '../Common/ScorePercentage.jsx';
import history from '../../history';
const { FormattedMessage, FormattedHTMLMessage } = AppLocaleProvider;
const { Column } = Table;
@inject('ObservationsStore')
@observer
class DriverPerformance extends React.Component {
  pageLoadLogger = new PageLoadLogger('Driving performance');

  componentDidMount() {
    const isRedirect = !!JSON.parse(sessionStorage.getItem('externalRedirect'));
    if (isRedirect) {
      sessionStorage.setItem('externalRedirect', false);
      history.replace(`/safetysecure`, '_self');
    }
    this.pageLoadLogger.addRequest(
      this.props.ObservationsStore.getAllObservations()
    );
    this.pageLoadLogger.capture();
  }

  render() {
    const { ObservationsStore } = this.props;

    const observationTableHeader = (
      <span className="driver-performance-observation-table-header-container">
        <span className="driver-performance-observation-table-header-observation">
          <FormattedMessage
            id="App.DrivingPerformance.Observation"
            defaultMessage="Observation"
          />
        </span>
        <span className="driver-performance-observation-table-header-percentage">
          <FormattedMessage
            id="App.DrivingPerformance.ContributionToSafetyScore"
            defaultMessage="Contribution to safety score"
          />
        </span>
      </span>
    );

    return (
      <AppLayout>
        <BackBreadcrumb
          to="/safety"
          data-automation-id="sd-ui-driver-navigation-breadcrumb-safety"
        >
          <FormattedMessage
            id="App.Navigation.BackToDriverSafetyOverview"
            defaultMessage="Back to Driver Safety overview"
          />
        </BackBreadcrumb>

        <Row>
          <Col span={24}>
            <Notifications />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <h1>
              <FormattedMessage
                id="App.DrivingPerformance.MyDrivingPerformance"
                defaultMessage="My driving performance"
              />
            </h1>
          </Col>
        </Row>

        {!ObservationsStore.loadingErrors.getAllObservations && (
          <Row>
            <Col span={24}>
              {ObservationsStore.loading.getAllObservations && (
                <Card loading={true} />
              )}

              {!ObservationsStore.loading.getAllObservations && (
                <div>
                  <Row>
                    <Col span={24}>
                      <div className="driver-performance-instructions">
                        <FormattedMessage
                          id="App.DrivingPerformance.Instructions"
                          defaultMessage="The observations below contributed to your Safety Score last week. Reduce the occurrence of these observations to improve your Safety Score."
                        />
                      </div>
                    </Col>
                  </Row>

                  <Table
                    dataSource={ObservationsStore.observations}
                    rowKey="observationName"
                    pagination={false}
                    size="medium"
                    locale={{
                      emptyText: (
                        <FormattedHTMLMessage
                          id="App.DrivingPerformance.NoObservationsBody"
                          defaultMessage="You achieved the best safety score possible.<br/>Keep up the good work!"
                        />
                      )
                    }}
                    className="driver-performance-observation-table"
                    onHeaderRow={() => ({
                      className: 'driver-performance-observation-table-header'
                    })}
                    onRow={record => ({
                      className:
                        'driver-performance-observation-table-body linked',
                      onClick: () => {
                        this.props.history.replace(
                          `/observation/${encodeURIComponent(
                            record.observationName
                          )}`
                        );
                      }
                    })}
                  >
                    {(ObservationsStore.observations.length ||
                      ObservationsStore.loading.getAllObservations) && (
                      <Column
                        className="driver-performance-column-observation"
                        title={observationTableHeader}
                        colSpan={2}
                        dataIndex="observationName"
                        key="name"
                      />
                    )}
                    {(ObservationsStore.observations.length ||
                      ObservationsStore.loading.getAllObservations) && (
                      <Column
                        className="driver-performance-column-percentage"
                        colSpan={0}
                        dataIndex="scorePercentage"
                        key="percentage"
                        render={text => <ScorePercentage value={text} />}
                      />
                    )}
                    {!ObservationsStore.observations.length &&
                      !ObservationsStore.loading.getAllObservations && (
                        <Column
                          title={
                            <FormattedMessage
                              id="App.DrivingPerformance.NoObservationsHeader"
                              defaultMessage="No observations reported!"
                            />
                          }
                          key="no-data"
                          colSpan={2}
                        />
                      )}
                  </Table>
                </div>
              )}
            </Col>
          </Row>
        )}
      </AppLayout>
    );
  }
}

export default DriverPerformance;



// WEBPACK FOOTER //
// ./src/containers/DriverPerformance/DriverPerformance.jsx